import EmbeddedAuthForm, { View } from './EmbeddedAuthForm';

export default EmbeddedAuthForm;
export type { View };